/**
 * Fassungen der Rechtstexte, die die App anzeigt (Fassungszeile der Seiten, Zustimmungsdialog).
 * Muessen den Konstanten der API gleichen (packages/api/src/lib/subscription-consent.ts,
 * CURRENT_CONSENT_VERSIONS): der Dialog schickt die angezeigte Fassung mit, die API weist jede
 * andere mit 409 consent_version_stale ab. So kann ein Tab oder Bundle von vor einem Livegang
 * keine neue Fassung bestaetigen (Rechtspruefung 22.09.2026, Codex-Delta Blocker 1). Bei einem
 * Drift antwortet die API auf JEDE Zustimmung mit 409, das faellt sofort auf.
 */
export const LEGAL_VERSIONS = {
  // B386/B381, 2026-10-11: expired-account access and the October 8 MSS section 11 change need new versions.
  on_bilgilendirme: 'v2.4-2026-10-11',
  mesafeli_satis: 'v2.4-2026-10-11',
  cayma_vazgecme: 'v2.0-2026-09-22',
  iade_iptal: 'v2.4-2026-10-11',
} as const

/** Datum der letzten Aenderung, das die drei Rechtsseiten neben der Fassung zeigen. */
export const LEGAL_LAST_UPDATED = '11 Ekim 2026'
